import React, { useState } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";

import { OffenseGameplan } from "./OffenseGameplan";
import { Side } from "../../../types/DepthChartTypes";
import { AllSideTabs } from "../../../constants";

// Helper function to format side names
const formatSideName = (side: Side): string => {
  // For sides with spaces, split by space, otherwise treat as a single word
  const words = side.split(' ');
  
  // Convert each word to title case
  return words
    .map(word => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
};

export const GameplanRoot = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedSide, setSelectedSide] = useState<Side>("OFFENSE");

  // Handle tab change
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const newSide = AllSideTabs[newValue].value;
    setSelectedTab(newValue);
    setSelectedSide(newSide);
  };

  // Render the gameplan content based on the selected side
  const renderGameplanContent = () => {
    switch (selectedSide) {
      case "OFFENSE":
        return <OffenseGameplan />;
      case "DEFENSE":
      case "PUNT":
      case "PUNT_RETURN":
      case "KICKOFF":
      case "KICKOFF_RETURN":
      case "FIELD_GOAL":
      case "FIELD_GOAL_BLOCK":
        return (
          <Typography variant="h5" sx={{ textAlign: "center", py: 4 }}>
            {formatSideName(selectedSide)} gameplan is not yet implemented
          </Typography>
        );
      default:
        return (
          <Typography variant="h5" color="error" sx={{ textAlign: "center", py: 4 }}>
            Unknown gameplan type
          </Typography>
        );
    }
  };

  return (
    <Box 
      sx={{ 
        p: 1,
        width: "100%",
        bgcolor: "#121212",
        color: "white",
        height: "calc(100vh - 100px)",
        boxSizing: "border-box",
      }}
    >
      {/* Tabs for gameplan types */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "rgba(123, 45, 58, 0.9)",
            },
            "& .MuiTab-root": {
              color: "rgba(255, 255, 255, 0.7)",
              "&.Mui-selected": {
                color: "white",
              },
            },
          }}
        >
          {AllSideTabs.map((tab, index) => (
            <Tab
              key={tab.value}
              label={tab.label}
              id={`gameplan-tab-${index}`}
            />
          ))}
        </Tabs>
      </Box>

      {/* Main content area */}
      <Box
        sx={{
          width: "100%",
          height: "calc(100vh - 180px)",
          overflow: "auto",
        }}
      >
        {renderGameplanContent()}
      </Box>
    </Box>
  );
};


